import {CentrifugeProtobuf} from './protobuf.js';
export default CentrifugeProtobuf;



// WEBPACK FOOTER //
// ./src/index_protobuf.js